import {QueryCommand} from "xmgoing-server";

export function savePrintHtml(records,backFun){
    const queryCommand = new QueryCommand({
        url:`/api/go-lcc/execute/saveByTableCode/TB_PRINT_FORM_LOG`,
        method:'POST'
    });
    queryCommand.executeQueryPromise({params:{...records}}).then((res:any)=>{
        backFun&&backFun(res);
    });
}